import { render, staticRenderFns } from "./ProductMetaPrice.vue?vue&type=template&id=708e55d2"
import script from "./ProductMetaPrice.vue?vue&type=script&lang=js"
export * from "./ProductMetaPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports